import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "modal-header" };
const _hoisted_2 = { class: "header-text" };
const _hoisted_3 = { class: "modal-title" };
const _hoisted_4 = { class: "modal-description" };
const _hoisted_5 = { class: "modal-body" };
const _hoisted_6 = { class: "product-info" };
const _hoisted_7 = { class: "product-image" };
const _hoisted_8 = ["src", "alt"];
const _hoisted_9 = { class: "product-name" };
const _hoisted_10 = { class: "product-description" };
const _hoisted_11 = { class: "options-section" };
const _hoisted_12 = { class: "options-title" };
const _hoisted_13 = { class: "options-list" };
const _hoisted_14 = ["onClick"];
const _hoisted_15 = { class: "supplement-image" };
const _hoisted_16 = ["src", "alt"];
const _hoisted_17 = { class: "supplement-info" };
const _hoisted_18 = { class: "supplement-name" };
const _hoisted_19 = { class: "supplement-price" };
const _hoisted_20 = { class: "supplement-checkbox" };
const _hoisted_21 = { class: "quantity-section" };
const _hoisted_22 = { class: "quantity-label" };
const _hoisted_23 = { class: "quantity-controls" };
const _hoisted_24 = ["disabled"];
const _hoisted_25 = { class: "quantity-display" };
const _hoisted_26 = { class: "modal-footer" };
const _hoisted_27 = { class: "total-price" };
const _hoisted_28 = { class: "price-label" };
const _hoisted_29 = { class: "price-value" };
const _hoisted_30 = { class: "action-buttons" };
import { ref, computed, watch } from 'vue';
import htmlToText from '@/utils/html-to-text';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
export default /*@__PURE__*/ _defineComponent({
    __name: 'SaladCustomizationModal',
    props: {
        product: {},
        selectedSize: {}
    },
    emits: ["close", "add-to-cart"],
    setup(__props, { emit: __emit }) {
        const store = useStore();
        const { t } = useI18n();
        const props = __props;
        const emit = __emit;
        const availableSauces = [
            {
                id: "sauce-balsamique",
                name: "Sauce Balsamique",
                price: 1.0,
                extra_cost_price: 1.0,
                image_url: "/images/supplements/sauce-balsamique.png",
                quantity: 0,
                type: "supplement",
                size: "Normale",
                isDefault: false,
                isAvailable: true
            },
            {
                id: "sauce-francaise",
                name: "Sauce Française",
                price: 1.0,
                extra_cost_price: 1.0,
                image_url: "/images/supplements/sauce-francaise.png",
                quantity: 0,
                type: "supplement",
                size: "Normale",
                isDefault: false,
                isAvailable: true
            },
            {
                id: "sauce-italienne",
                name: t('forms.italianSauce'),
                price: 1.0,
                extra_cost_price: 1.0,
                image_url: "/images/supplements/sauce-italienne.png",
                quantity: 0,
                type: "supplement",
                size: "Normale",
                isDefault: false,
                isAvailable: true
            }
        ];
        const selectedSauces = ref({});
        const quantity = ref(1);
        const selectedSauceItems = computed(() => {
            return availableSauces.filter(sauce => selectedSauces.value[sauce.name]);
        });
        const formatPrice = (price) => {
            return `${price.toFixed(2)} CHF`;
        };
        const toggleSauce = (sauceName) => {
            selectedSauces.value[sauceName] = !selectedSauces.value[sauceName];
        };
        const incrementQuantity = () => {
            quantity.value++;
        };
        const decrementQuantity = () => {
            if (quantity.value > 1) {
                quantity.value--;
            }
        };
        const calculateTotal = () => {
            if (!props.selectedSize)
                return 0;
            const isDelivery = store.getters['orderType/isDelivery'];
            const basePrice = isDelivery && props.selectedSize.priceLivraison
                ? parseFloat(props.selectedSize.priceLivraison) || 0
                : parseFloat(props.selectedSize.price) || 0;
            const saucesPrice = availableSauces.reduce((total, sauce) => {
                return selectedSauces.value[sauce.name] ? total + sauce.extra_cost_price : total;
            }, 0);
            return (basePrice + saucesPrice) * quantity.value;
        };
        const closeModal = () => {
            selectedSauces.value = {};
            quantity.value = 1;
            emit('close');
        };
        const handleAddToCart = () => {
            if (!props.product || !props.selectedSize)
                return;
            const selectedSauceNames = availableSauces
                .filter(sauce => selectedSauces.value[sauce.name])
                .map(sauce => sauce.name);
            selectedSauceNames.forEach(sauceName => {
                store.dispatch('features/toggleFeature', sauceName);
            });
            const selectedSupplements = availableSauces
                .filter(sauce => selectedSauces.value[sauce.name])
                .map(sauce => ({
                id: sauce.id,
                name: sauce.name,
                extra_cost_price: sauce.extra_cost_price,
                quantity: 1,
                type: sauce.type,
                size: sauce.size
            }));
            const cartIngredients = (props.product.ingredients || []).map(ing => ({
                id: ing.id,
                name: ing.name,
                extra_cost_price: ing.price || 0,
                quantity: ing.isDefault ? 1 : 0,
                isDefault: ing.isDefault,
                size: props.selectedSize?.name || props.selectedSize?.size || ''
            }));
            const event = {
                product: props.product,
                size: props.selectedSize,
                quantity: quantity.value,
                ingredients: cartIngredients,
                supplements: selectedSupplements,
                notes: ''
            };
            emit('add-to-cart', event);
            closeModal();
        };
        watch(() => props.product, () => {
            selectedSauces.value = {};
            quantity.value = 1;
        }, { immediate: true });
        return (_ctx, _cache) => {
            return (__props.product)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "modal-overlay",
                    onClick: closeModal
                }, [
                    _createElementVNode("div", {
                        class: "modal-content",
                        onClick: _cache[0] || (_cache[0] = _withModifiers(() => { }, ["stop"]))
                    }, [
                        _createElementVNode("div", _hoisted_1, [
                            _createElementVNode("div", _hoisted_2, [
                                _createElementVNode("h2", _hoisted_3, _toDisplayString(_unref(t)('pos.customizeSalad')), 1),
                                _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(t)('pos.addSaucesForSalad')), 1)
                            ]),
                            _createElementVNode("button", {
                                onClick: closeModal,
                                class: "close-button"
                            }, [...(_cache[1] || (_cache[1] = [
                                    _createElementVNode("i", { class: "fas fa-times" }, null, -1)
                                ]))])
                        ]),
                        _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("div", _hoisted_6, [
                                _createElementVNode("div", _hoisted_7, [
                                    _createElementVNode("img", {
                                        src: __props.product.image || '/imgs/salad-placeholder.jpg',
                                        alt: __props.product.name,
                                        class: "product-img"
                                    }, null, 8, _hoisted_8)
                                ]),
                                _createElementVNode("h3", _hoisted_9, _toDisplayString(__props.product.name), 1),
                                _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(htmlToText)(__props.product.description || '')), 1)
                            ]),
                            _createElementVNode("div", _hoisted_11, [
                                _createElementVNode("h4", _hoisted_12, _toDisplayString(_unref(t)('pos.chooseYourSauces')), 1),
                                _createElementVNode("div", _hoisted_13, [
                                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(availableSauces, (sauce) => {
                                        return _createElementVNode("div", {
                                            key: sauce.id,
                                            class: _normalizeClass(["supplement-card", { 'selected': selectedSauces.value[sauce.name] }]),
                                            onClick: ($event) => (toggleSauce(sauce.name))
                                        }, [
                                            _createElementVNode("div", _hoisted_15, [
                                                _createElementVNode("img", {
                                                    src: sauce.image_url,
                                                    alt: sauce.name,
                                                    class: "supplement-img"
                                                }, null, 8, _hoisted_16)
                                            ]),
                                            _createElementVNode("div", _hoisted_17, [
                                                _createElementVNode("span", _hoisted_18, _toDisplayString(sauce.name), 1),
                                                _createElementVNode("span", _hoisted_19, "+" + _toDisplayString(formatPrice(sauce.extra_cost_price)), 1)
                                            ]),
                                            _createElementVNode("div", _hoisted_20, [
                                                _createElementVNode("i", {
                                                    class: _normalizeClass(selectedSauces.value[sauce.name] ? 'fas fa-check-circle' : 'far fa-circle')
                                                }, null, 2)
                                            ])
                                        ], 10, _hoisted_14);
                                    }), 64))
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_21, [
                                _createElementVNode("label", _hoisted_22, _toDisplayString(_unref(t)('common.quantity')) + " :", 1),
                                _createElementVNode("div", _hoisted_23, [
                                    _createElementVNode("button", {
                                        onClick: decrementQuantity,
                                        disabled: quantity.value <= 1,
                                        class: "quantity-btn"
                                    }, " - ", 8, _hoisted_24),
                                    _createElementVNode("span", _hoisted_25, _toDisplayString(quantity.value), 1),
                                    _createElementVNode("button", {
                                        onClick: incrementQuantity,
                                        class: "quantity-btn"
                                    }, " + ")
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_26, [
                            _createElementVNode("div", _hoisted_27, [
                                _createElementVNode("span", _hoisted_28, _toDisplayString(_unref(t)('pos.total')) + " :", 1),
                                _createElementVNode("span", _hoisted_29, _toDisplayString(formatPrice(calculateTotal())), 1)
                            ]),
                            _createElementVNode("div", _hoisted_30, [
                                _createElementVNode("button", {
                                    onClick: closeModal,
                                    class: "cancel-btn"
                                }, _toDisplayString(_unref(t)('common.cancel')), 1),
                                _createElementVNode("button", {
                                    onClick: handleAddToCart,
                                    class: "add-to-cart-btn"
                                }, [
                                    _cache[2] || (_cache[2] = _createElementVNode("i", { class: "fas fa-shopping-cart" }, null, -1)),
                                    _createTextVNode(" " + _toDisplayString(_unref(t)('pos.addToCart')), 1)
                                ])
                            ])
                        ])
                    ])
                ]))
                : _createCommentVNode("", true);
        };
    }
});
